import { exportRequestsFactory } from '@eas/common-web';
import { ExportTag } from '../../../enums';

export const ExportRequests = exportRequestsFactory({
  exportTag: ExportTag.EXPORT_REQUESTS_GRID,
});
